import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPackageRegistry = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M25.1382 48.6219V28.2305L7.28481 17.8919V37.7891C7.28481 37.9353 7.32147 38.0727 7.39478 38.2012C7.4681 38.3293 7.57784 38.439 7.724 38.5304L25.1382 48.6219ZM29.423 48.6219L46.8371 38.5304C46.9833 38.439 47.0931 38.3293 47.1664 38.2012C47.2397 38.0727 47.2763 37.9353 47.2763 37.7891V17.8919L29.423 28.2305V48.6219ZM24.699 53.2966L5.58231 42.2932C4.76915 41.8247 4.13547 41.1987 3.68128 40.415C3.22709 39.6309 3 38.7701 3 37.8327V16.1673C3 15.2299 3.22709 14.3691 3.68128 13.585C4.13547 12.8013 4.76915 12.1753 5.58231 11.7068L24.699 0.703425C25.5117 0.234477 26.3722 0 27.2806 0C28.189 0 29.0495 0.234477 29.8622 0.703425L48.9788 11.7068C49.792 12.1753 50.4257 12.8013 50.8799 13.585C51.3341 14.3691 51.5612 15.2299 51.5612 16.1673V37.8327C51.5612 38.7701 51.3341 39.6309 50.8799 40.415C50.4257 41.1987 49.792 41.8247 48.9788 42.2932L29.8622 53.2966C29.0495 53.7655 28.189 54 27.2806 54C26.3722 54 25.5117 53.7655 24.699 53.2966ZM38.2947 18.1447L44.9197 14.3434L27.7198 4.39479C27.5736 4.30338 27.4272 4.25767 27.2806 4.25767C27.1339 4.25767 26.9875 4.30338 26.8414 4.39479L20.6391 7.96546L38.2947 18.1447ZM27.2806 24.5391L33.922 20.6935L16.2829 10.4978L9.64145 14.3434L27.2806 24.5391Z",
		fill: "#597EF7"
	})]
});
const ForwardRef = forwardRef(SvgPackageRegistry);
export { ForwardRef as ReactComponent };
